<script>
export default {
    methods: {
        getParameters() {
            let parametersString = window.location.search.substring(1).replace(/&$/, '');
            const parametersList = parametersString.split('&');
            let parameters = {};

            parametersList.forEach(parameter => {
                if(parameter !== '') {
                    const data = parameter.split('=');
                    const key = data[0];
                    const value = data[1];
                    parameters[key] = value;
                }
            });

            return parameters;
        },

        updateParameter(parameter, value) {
            if(!this.$store.state.page.browserBackButton) return;

            let parameters = this.getParameters();
            parameters[parameter] = value;
            let parametersString = '';

            for (const item in parameters) {
                const string = `${item}=${parameters[item]}&`;
                parametersString += string;
            }

            parametersString = parametersString.replace(/&$/, '');

            const location = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + parametersString;
            window.history.pushState({path: location}, '', location);
        },
    },
};
</script>
